import { DefaultButton, Icon, IContextualMenuItem, mergeStyleSets } from "@fluentui/react";
import { baseUrlUser } from "../../../../constants/url.constant";
import { ContextualMenuItem } from "../../../home/models/OtherTypes"
import { HomePageLinkType } from "../../models/ProductModel";
import productLogo from "../../../../assets/images/products.png";

const classNames = mergeStyleSets({
    menu: {
        textAlign: 'center',
        //width: 150,
        selectors: {
            '.ms-ContextualMenu-item': {
                height: 'auto',
            },
        },
    }
});

export type ShopByMenuProps = {
    list: ContextualMenuItem[];
    showAllBrands: () => void;
}

export default function ShopByMenu({ list, showAllBrands }: ShopByMenuProps) {
    const iconSize = 35;

    const createMenuItems = (): IContextualMenuItem[] => {
        let items: IContextualMenuItem[] = [];

        items.push({
            key: 'all-brands',
            text: "ALL Brands",
            iconProps: { iconName: "" },
            onClick: showAllBrands,
            onRenderIcon: () => (<img src={productLogo} alt="" width={iconSize} height={iconSize} />)
        })

        for (let i = 0; i < list.length; i++) {
            const item = list[i];

            items.push({
                key: item.key,
                text: item.text,
                iconProps: { iconName: "" },
                onClick: () => {
                    window.open(`/products?type=${HomePageLinkType.quickLink}&&key=${item.key}`, "_self");
                },
                onRenderIcon: () => (<img src={baseUrlUser + item.imageUrl} alt="" width={iconSize} height={iconSize} />)
            })
        }

        return items;
    }

    const menuView = () => {
        return <>
            <DefaultButton
                menuProps={{
                    shouldFocusOnMount: false,
                    items: createMenuItems(),
                    calloutProps: {
                        calloutWidth: 230,
                        className: classNames.menu,
                        styles: {
                            // Makes the white panel container have curved borders
                            calloutMain: {
                                borderRadius: 10,
                                //overflow: 'hidden', // Ensures inner items respect the curve
                                padding: 10
                            },
                        },
                    }
                }}
                className="my-context-menu shopping-by-menu context-menu-text"
                styles={{
                    root: { height: 40, minWidth: 40, width: 40, border: "none" },
                    menuIcon: { display: "none !important" }
                }}
                style={{
                    backgroundColor: "transparent",
                    height: 35,
                    fontSize: "x-large",
                    paddingLeft: 5
                }}>
                <Icon iconName="NumberedListTextMirrored" className="font-larger" />
            </DefaultButton>
        </>;
    }

    return <>
        {menuView()}
    </>;
}